import _ from 'lodash';
import * as Api from './api';

const initialState = {
  status: null,
  org: null,
  error: null,
  acceptError: null,
};

const mutations = {
  CHECKING(state) {
    state.status = 'checking';
  },
  BAD_INVITE_CODE(state, error) {
    state.status = 'bad_invite';
    state.error = _.get(error, 'response.data.msg', 'unknown error');
  },
  INVITED_TO_ORG(state, org) {
    state.status = 'good_invite';
    state.org = org;
  },
  ACCEPTING_INVITE(state) {
    state.status = 'accepting_invite';
    state.acceptError = null;
  },
  FAILED_TO_ACCEPT(state, error) {
    state.status = 'bad_accept';
    state.acceptError = _.get(error, 'response.data.msg', 'unknown error');
  },
  ACCEPTED(state) {
    state.status = 'accepted';
    state.acceptError = null;
  },
};

const actions = {
  async checkInvitation({ commit }, { code }) {
    commit('CHECKING');
    try {
      const org = await Api.checkInvite(code);
      commit('INVITED_TO_ORG', org);
    } catch (e) {
      commit('BAD_INVITE_CODE', e);
    }
  },
  async acceptInvitation({ commit, dispatch }, { code }) {
    commit('ACCEPTING_INVITE');
    try {
      const { newAccessItem, org } = await Api.acceptInvite(code);
      commit('ACCEPTED');
      dispatch('users/joinOrg', newAccessItem, { root: true });
      dispatch('orgs/addOrg', org, { root: true });
    } catch (e) {
      commit('FAILED_TO_ACCEPT', e);
    }
  },
  async loginOrRegister({ commit, dispatch }, payload) {
    commit('ACCEPTING_INVITE');
    try {
      const { user, token } = await Api.loginOrRegister(payload);
      commit('ACCEPTED');
      await dispatch('users/setUser', { user, token }, { root: true });
    } catch (e) {
      commit('FAILED_TO_ACCEPT', e);
    }
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/Invite/index.js